import Vue from 'vue'
import {
  URL_USER,
  URL_USER_LOGON,
  URL_USER_ADMIN_LOGON,
  URL_USER_CHANGE_PASSWORD,
  URL_USER_VERIFY,
  URL_USER_RESET_PASSWORD,
  URL_USER_RESET_PASSWORD_CONFIRMED
} from '@/constants/urls.js'
import { LOCAL_STORE_NAMES } from '@/constants/settings.js'
import {
  ACCOUNT, ERRORS, AXIOS_REQUESTS,
  CURRENT_USER, CURRENT_USER_EXPIRATIONS_DATES
} from '@/constants/store.js'

// import persistance from '@/utils/persistStatesHelper'

const initState = () => {
  const fromLocalStorage = Vue.helpers.getFromLocalStorage(LOCAL_STORE_NAMES.USER)
  if (fromLocalStorage) {
    return {
      [ACCOUNT.STATE.IS_LOGGED_IN]: fromLocalStorage[ACCOUNT.STATE.IS_LOGGED_IN] || false,
      [ACCOUNT.STATE.TOKEN]: fromLocalStorage[ACCOUNT.STATE.TOKEN] || null,
      [ACCOUNT.STATE.PARTICIPANT_TYPE]: fromLocalStorage[ACCOUNT.STATE.PARTICIPANT_TYPE] || null,
      [ACCOUNT.STATE.USER_NAME]: fromLocalStorage[ACCOUNT.STATE.USER_NAME] || null
    }
  } else {
    return {
      [ACCOUNT.STATE.IS_LOGGED_IN]: false,
      [ACCOUNT.STATE.TOKEN]: null,
      [ACCOUNT.STATE.PARTICIPANT_TYPE]: null,
      [ACCOUNT.STATE.USER_NAME]: null
    }
  }
}

const state = initState()

const actions = {
  async [ACCOUNT.ACTIONS.REGISTER_USER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.LOG_IN_USER] ({ dispatch, commit }, account) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_LOGON}`,
      model: account
    }
    try {
      const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
      commit(ACCOUNT.MUTATIONS.LOGIN_SUCCESS, resp.data)
    } catch (error) {
      commit(ACCOUNT.MUTATIONS.LOGIN_ERROR)
      throw error
    }
  },
  async [ACCOUNT.ACTIONS.LOG_IN_ADMIN] ({ dispatch, commit }, account) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_ADMIN_LOGON}`,
      model: account
    }
    try {
      const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
      commit(ACCOUNT.MUTATIONS.LOGIN_SUCCESS, resp.data)
    } catch (error) {
      commit(ACCOUNT.MUTATIONS.LOGIN_ERROR)
      throw error
    }
  },
  async [ACCOUNT.ACTIONS.CHANGE_PASSWORD] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_CHANGE_PASSWORD}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ACCOUNT.MUTATIONS.SET_USER_INFO, {
      name: ACCOUNT.STATE.TOKEN,
      value: resp.data.token || null
    })
  },
  async [ACCOUNT.ACTIONS.SET_USER_NAME]  ({ commit }, userName) {
    commit(ACCOUNT.MUTATIONS.SET_USER_INFO, {
      name: ACCOUNT.STATE.USER_NAME,
      value: userName || null
    })
  },
  async [ACCOUNT.ACTIONS.UPDATE_PARTICIPANT_TYPE]  ({ commit }, participantType) {
    commit(ACCOUNT.MUTATIONS.SET_USER_INFO, {
      name: ACCOUNT.STATE.PARTICIPANT_TYPE,
      value: participantType || null
    })
  },
  async [ACCOUNT.ACTIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE]  ({ commit }) {
    commit(ACCOUNT.MUTATIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE)
  },
  async [ACCOUNT.ACTIONS.CONFIRM_EMAIL] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_VERIFY}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.RESET_PASSWORD] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_RESET_PASSWORD}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.RESET_PASSWORD_CONFIRMED] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_RESET_PASSWORD_CONFIRMED}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.LOG_OUT] ({ commit, dispatch }) {
    commit(ACCOUNT.MUTATIONS.LOG_OUT)
    await dispatch(`${CURRENT_USER.NAMESPACE}/${CURRENT_USER.ACTIONS.CLEAR_CURRENT_USER_INFO}`, null, { root: true })
    await dispatch(`${CURRENT_USER_EXPIRATIONS_DATES.NAMESPACE}/${CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.CLEAR_EXPIRATION_DATES}`, null, { root: true })
    // commit('reset')
  }
}

const mutations = {
  [ACCOUNT.MUTATIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE] (state) {
    const startState = initState()
    if (initState.isLoggedIn !== state.isLoggedIn) {
      Object.keys(startState).forEach((key) => {
        state[key] = startState[key]
      })
    }
  },
  [ACCOUNT.MUTATIONS.LOGIN_ERROR] (state) {
    state[ACCOUNT.STATE.IS_LOGGED_IN] = false
    state[ACCOUNT.STATE.TOKEN] = null
    state[ACCOUNT.STATE.PARTICIPANT_TYPE] = null
    state[ACCOUNT.STATE.USER_NAME] = null
  },
  [ACCOUNT.MUTATIONS.SET_USER_INFO] (state, prop) {
    Vue.set(state, prop.name, prop.value)
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, null)
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, {
      [ACCOUNT.STATE.IS_LOGGED_IN]: true,
      [ACCOUNT.STATE.TOKEN]: state[ACCOUNT.STATE.TOKEN],
      [ACCOUNT.STATE.PARTICIPANT_TYPE]: state[ACCOUNT.STATE.PARTICIPANT_TYPE],
      [ACCOUNT.STATE.USER_NAME]: state[ACCOUNT.STATE.USER_NAME]
    })
  },
  [ACCOUNT.MUTATIONS.LOGIN_SUCCESS] (state, model) {
    state[ACCOUNT.STATE.IS_LOGGED_IN] = true
    state[ACCOUNT.STATE.TOKEN] = model.token
    state[ACCOUNT.STATE.PARTICIPANT_TYPE] = model.participantType
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, {
      [ACCOUNT.STATE.IS_LOGGED_IN]: true,
      [ACCOUNT.STATE.TOKEN]: state[ACCOUNT.STATE.TOKEN],
      [ACCOUNT.STATE.PARTICIPANT_TYPE]: state[ACCOUNT.STATE.PARTICIPANT_TYPE],
      [ACCOUNT.STATE.USER_NAME]: state[ACCOUNT.STATE.USER_NAME]
    })
  },
  [ACCOUNT.MUTATIONS.LOG_OUT] (state) {
    state[ACCOUNT.STATE.IS_LOGGED_IN] = false
    state[ACCOUNT.STATE.TOKEN] = null
    state[ACCOUNT.STATE.PARTICIPANT_TYPE] = null
    state[ACCOUNT.STATE.USER_NAME] = null
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, null)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
